export const NEW_CARGO = {
  IsWeight: 0,
  Name: 'Новый груз'
};
